import React from 'react';

import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { selectedProductSelector } from 'ctm-selectors';
import { ContainerWrapper } from '../products/container_wrapper';

import { ProductPriceStickyBar } from './widget/product_price_sticky_bar';
import { ProductCard } from './widget/product_card';
import { ProductContent } from './widget/product_content';
import { BackToResultsButton } from '../comparison/common/back_to_results_button';
import { PriceDisclaimer } from './common/price_disclaimer';
import { coverTypeStateMapping } from '../products/filters/common/filter_store_mapping';

const _PolicyProductSingleColumn = ({ quote, stagedValue, pristineValue }) => {
    return (
        <div className="test-policyProduct-single-column">
            <ProductPriceStickyBar quote={quote} pristineValue={pristineValue} />
            <ContainerWrapper padding={['32', '16', '0', '16']}>
                <BackToResultsButton label="Back to all results" variant="tertiary" />
            </ContainerWrapper>
            <ContainerWrapper padding={['16', '16', '0', '16']}>
                <PriceDisclaimer />
            </ContainerWrapper>
            <ContainerWrapper padding={['16', '0', '0', '0']}>
                <ProductCard quote={quote} />
            </ContainerWrapper>
            <ContainerWrapper padding={['40', '16', '0', '16']}>
                <ProductContent quote={quote} stagedValue={stagedValue} pristineValue={pristineValue} />
            </ContainerWrapper>
            <ContainerWrapper padding={['40', '16', '108', '16']}>
                <BackToResultsButton label="Back to all results" variant="secondary" />
            </ContainerWrapper>
        </div>
    );
};

_PolicyProductSingleColumn.propTypes = {
    quote: PropTypes.object.isRequired,
    stagedValue: PropTypes.string.isRequired,
    pristineValue: PropTypes.string.isRequired
};

const mapStateToProps = (state) => {
    const quote = selectedProductSelector(state);
    const { stagedValue, pristineValue } = coverTypeStateMapping(state);
    return {
        quote,
        stagedValue,
        pristineValue
    };
};

const PolicyProductSingleColumn = connect(mapStateToProps)(_PolicyProductSingleColumn);

export { PolicyProductSingleColumn };
